import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-import',
  templateUrl: './wallet-import.component.html',
  styleUrls: ['./wallet-import.component.scss']
})
export class WalletImportComponent {

}
